import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { MultiSelectApi } from '../../Widgets/MultiSelect'
import { Utils } from '../../Utils/Utils';
import { DateUtils } from '../../Utils/DateUtils';
import { StringUtils } from '../../Utils/StringUtils';
import { ArrayUtils } from '../../Utils/ArrayUtils';

var tableDom = "<'row'<'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";

export interface ChannelDetailPageOptions extends PageOptionsBase {
    urlList: string;
    urlDetail: string;
    localizer: {
        StatusEnabled: string;
        StatusDisabled: string;
        DetailsLink: string;
    }
}

export class ChannelDetailPage extends PageBase<ChannelDetailPageOptions> {

    private static rolesInit: string;
    private static msApi: MultiSelectApi;

    private _tableOptions: DatatableOptions;
    private _table: Datatable;
    private _tableId: string;

    constructor(options: ChannelDetailPageOptions) {
        super(options);
        var getDetailUrl = (rowData: any): string => (`${options.urlDetail}/${rowData.Id}`);

        this._tableId = "tableGames";
        this._tableOptions = {
            url: this._options.urlList,
            dom: tableDom,
            rowId: 'Id',
            autoWidth: true,
            columns: [
                {
                    data: 'ConfigurationName',
                    className: "bold",
                    render: (data: any, type: any, rowData: any) =>
                        (`<a id='lnkName${rowData.Id}' href='${getDetailUrl(rowData)}'>${data}</a>`)
                },
                {
                    data: "GameName",
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnCode${rowData.Id}'>${data}</span>`)
                },
                {
                    data: "GameCode",
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnCode${rowData.Id}'>${data}</span>`)
                },
                {
                    data: "CurrencyCode",
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnCode${rowData.Id}'>${data}</span>`)
                },
                {
                    data: "ConfigurationStatus",
                    render: (data: any, type: any, rowData: any) => {
                        //var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
                        var css = `status-${data.toLowerCase()}`;
                        return `<span id='spnState${rowData.Id}' class='${css}'>${data}</span>`;
                    }
                },
                {
                    data: '',
                    sortable: false,
                    render: (data: any, type: any, rowData: any) =>
                        (`<a id='lnkDetail${rowData.Id}' href='${getDetailUrl(rowData)}'>${options.localizer.DetailsLink}</a>`)
                }
            ]
        };
        // === prepare table options
    }

    init(): void {
        ChannelDetailPage.msApi = new MultiSelectApi('roles');
        ChannelDetailPage.rolesInit = ChannelDetailPage.msApi.getSelectionValues();
        // == create 'new Datatable' instance
        if (Utils.isNullOrUndefined(this._tableOptions))
            return;
        this._table = new Datatable(this._tableId, this._tableOptions);
    }

    public static showForm(field: string, focusField: string) {
        $(".multi-hide").hide();
        $(".multi-show").show();

        $(".multi-show").closest(".form-group").removeClass("gray");

        var label = "#lbl" + field;
        var frm = "#frm" + field;
        $(label).hide();
        $(frm).show();

        $(label).closest(".form-group").addClass("gray");

        if (focusField) {
            $('#' + focusField).focus();
        }
    }

    public static hideForm(field: string) {
        var label = "#lbl" + field;
        var frm = "#frm" + field;
        $(label).show();
        $(frm).hide();

        ChannelDetailPage.msApi.setSelectionValues(ChannelDetailPage.rolesInit);

        $(label).closest(".form-group").removeClass("gray");
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/Customers/ChannelDetailPage.ts
 **/